import { render, staticRenderFns } from "./nature2_2.vue?vue&type=template&id=daca526c&scoped=true&"
import script from "./nature2_2.vue?vue&type=script&lang=js&"
export * from "./nature2_2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daca526c",
  null
  
)

export default component.exports